export function H1({ children, ...props }: React.ComponentProps<"h1">) {
  return (
    <div className="w-p mx-auto">
      <h3 {...props}>{children}</h3>
      <hr />
    </div>
  );
}

export function H2({ children, ...props }: React.ComponentProps<"h2">) {
  return (
    <div className="w-p mx-auto">
      <h4 {...props}>{children}</h4>
    </div>
  );
}

export function H3({ children, ...props }: React.ComponentProps<"h3">) {
  return (
    <div className="w-p mx-auto">
      <h5 {...props}>{children}</h5>
      <hr />
    </div>
  );
}

export function H4({ children, ...props }: React.ComponentProps<"h4">) {
  return (
    <div className="w-p mx-auto">
      <h6 {...props}>{children}</h6>
      <hr />
    </div>
  );
}
